import { withInstall } from '@bigin/utils'

import ConfigProvider from './src/config-provider'

export const BConfigProvider = withInstall(ConfigProvider)
export default BConfigProvider

export * from './src/config-provider'
